import * as React from 'react';

import { ThemeClasses } from './style';
import { addVersionId } from '../../../../utils/url';
import { HotelCategory } from '../HotelCategory';


export interface TitleProps {
    categoryName?: string;
    hotelName?: string;
    hotelLink?: string;
    iconWidth?: number;
    iconHeight?: number;
}

interface StyledTitleProps extends TitleProps {
    classes: ThemeClasses;
}


export class HotelTitle extends React.Component<StyledTitleProps, {}> {

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.container}>
                <div className={classes.hotelNameWrap}>
                    {this.renderHotelCategory()}
                    {this.renderHotel()}
                </div>
            </div>
        );
    }

    renderHotelCategory(): JSX.Element | null {
        const { classes } = this.props;

        if (!this.props.categoryName) {
            return null;
        }

        return (
            <div
                className={classes.hotelCategory}
                data-qa-node={'Title-HotelCategory'}
            >
                <HotelCategory name={this.props.categoryName} />
            </div>
        );
    }

    renderHotel(): JSX.Element | null {
        const { classes } = this.props;

        if (!this.props.hotelName) {
            return null;
        }

        if (!this.props.hotelLink) {
            return (
                <h1 className={classes.h1Text}>
                    <span
                        data-qa-node={'Title-HotelName'}
                        className={classes.hotelName}
                    >
                        Отель {this.props.hotelName}
                    </span>
                </h1>
            );
        }

        return (
            <a
                href={addVersionId(this.props.hotelLink)}
                className={classes.link}
            >
                {this.props.hotelName}
            </a>
        );
    }
}
